import { useState } from "react";
import ExpandModal from "@modals/ExpandModal";
import AlertsGrid from "./AlertsGrid";
import { FaExpandAlt } from "react-icons/fa";

const AlertsComponent = () => {
    const modalTitle = "Alerts";
    const [show, setShow] = useState(false);
    const componentType = "table";

    return (
        <>
            <div
                className="card h-100 mb-4 shadow"
                style={{ borderRadius: "16px" }}
            >
                <div className="card-body p-2" style={{ borderRadius: "16px" }}>
                    <div className="d-flex align-items-center justify-content-between px-2 pt-1">
                        <h5>{modalTitle}</h5>
                        <FaExpandAlt className="mx-1"
                                    style={{
                                        fontSize: "1.1rem",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setShow(true)} />
                    </div>
                    <div
                        className="border-top pt-2 mt-2"
                        id="alerts-report-render"
                    >
                        <AlertsGrid componentType={componentType} />
                    </div>
                </div>
            </div>
            <ExpandModal
                show={show}
                setShow={setShow}
                modalTitle={modalTitle}
            />
        </>
    );
};

export default AlertsComponent;
